@if ({
  manufacturerCampaignOverview: manufacturerCampaignOverview$ | async,
  errorOverview: errorOverview$ | async
  }; as type) {
  <!-- Filter and search -->
  <div class="manufacturer-campaign-filter" id="manufacturer-campaign-filter">
    <form (ngSubmit)="onSubmit()" #searchForm="ngForm" autocomplete="off">
      <ng-container>
        <div class="form-group row">
          <label for="productCode" class="col-md-2 col-form-label">{{
            'customManufacturerCampaign.search.productCode' | cxTranslate
          }}</label>
          <div class="col-md-2">
            <input type="text" id="productCode" class="form-control" ngModel name="productCode" [value]="productCode" />
          </div>
          <label for="manufacturerNumber" class="col-md-2 col-form-label">{{
            'customManufacturerCampaign.search.manufacturerNumber' | cxTranslate
          }}</label>
          <div class="col-md-2">
            <input type="text" id="manufacturerNumber" class="form-control" ngModel name="manufacturerNumber" [value]="manufacturerNumber" />
          </div>
          <label for="ean" class="col-md-1 col-form-label">{{
            'customManufacturerCampaign.search.ean' | cxTranslate
          }}</label>
          <div class="col-md-3">
            <input type="text" id="ean" class="form-control" ngModel name="ean" [value]="ean" />
          </div>
        </div>
        <div class="form-group row">
          <label for="ean" class="col-md-2 col-form-label">{{
            'customManufacturerCampaign.search.manufacturerId' | cxTranslate
          }}</label>
          <ng-select
            id="manufacturerId"
            class="col-xl-2"
            [searchable]="false"
            [clearable]="false"
            [(ngModel)]="manufacturerId"
            name="manufacturerId"
            >
            <ng-option value="">{{ 'customManufacturerCampaign.search.all' | cxTranslate }}</ng-option>
            @for (manufacturerMapping of manufacturerMappingList; track manufacturerMapping) {
              <ng-option [value]="manufacturerMapping.manufacturer">
                <div>{{ manufacturerMapping.manufacturer }}</div>
              </ng-option>
            }
          </ng-select>
          <label for="ean" class="col-md-2 col-form-label">{{
            'customManufacturerCampaign.search.campaignId' | cxTranslate
          }}</label>
          <ng-select
            id="campaignId"
            class="col-xl-6"
            [searchable]="false"
            [clearable]="false"
            [(ngModel)]="campaignId"
            name="campaignId"
            >
            <ng-option value="">{{ 'customManufacturerCampaign.search.all' | cxTranslate }}</ng-option>
            @for (manufacturerCampaign of manufacturerCampaignList; track manufacturerCampaign) {
              <ng-option [value]="manufacturerCampaign.id">
                <div>{{ manufacturerCampaign.id }} - {{manufacturerCampaign.name}}</div>
              </ng-option>
            }
          </ng-select>
        </div>
      </ng-container>
      <div class="form-group row">
        <div class="col-sm-3">
          <button class="btn btn-secondary btn-block mb-3" type="submit">
            {{ 'customManufacturerCampaign.buttons.search' | cxTranslate }}
          </button>
        </div>
        <div class="col-sm-3">
          <button class="btn btn-secondary btn-block mb-3" (click)="resetForm()">
            {{ 'customManufacturerCampaign.buttons.reset' | cxTranslate }}
          </button>
        </div>
        <div class="col-sm-6">
          <button type="button" class="btn btn-secondary btn-block mb-6" (click)="openInstruction()">
            {{ 'customManufacturerCampaign.buttons.instruction' | cxTranslate }}
          </button>
        </div>
      </div>
    </form>
    <div class="import-container">
      <hr>
        <div class="import-header row">
          <div class="col-9">
            <p class="title"> {{ 'customManufacturerCampaign.import.title' | cxTranslate }} </p>
            <p class="text"> {{ 'customManufacturerCampaign.import.text' | cxTranslate }} </p>
          </div>
          <div class="col-3">
            <p class="title"> {{ 'customManufacturerCampaign.export.title' | cxTranslate }}</p>
          </div>
        </div>
        <div class="form-group row import-buttons">
          <div class="col-sm-2 import-extra-column">
            &nbsp;
          </div>
          <div class="col-md-4 col-sm-6">
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="customCSVImport" (change)="onFileSelected($event)" (click)="$event.target.value=null">
              @if (!fileName) {
                <label class="custom-file-label" for="customCSVImport">
                  {{'customManufacturerCampaign.import.noFileSelected' | cxTranslate}}
                </label>
              }
              @if (fileName) {
                <label class="custom-file-label" for="customCSVImport">
                  {{fileName}}
                </label>
              }
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <button class="btn btn-secondary btn-block mb-3" type="button" (click) ="importFile()">
              {{ 'customManufacturerCampaign.buttons.import' | cxTranslate }}
            </button>
          </div>
          <div class="col-md-3 col-sm-6">
            <button class="btn btn-secondary btn-block mb-3" type="button" (click) ="openExport()">
              {{ 'customManufacturerCampaign.buttons.export' | cxTranslate }}
            </button>
          </div>
        </div>
        <hr>
        </div>
      </div>
      <div class="manufacturer-campaign-sort">
        <div class="form-group row">
          <label for="manufacturerCampaignSort" class="sort-label col-xl-2 col-form-label">{{
            'customManufacturerCampaign.sortOptions.label' | cxTranslate
          }}</label>
          <ng-select id="sortOptions" class="col-xl-2" [searchable]="false" [clearable]="false" (change)="onChangeSort()"
            [(ngModel)]="selectedSortOption">
            @for (sort of sortOptions; track sort) {
              <ng-option [value]="sort">{{
                'customManufacturerCampaign.sortOptions.' + sort | cxTranslate
              }}</ng-option>
            }
          </ng-select>
          <label for="sortDirections" class="sort-label col-xl-2 col-form-label">{{
            'customManufacturerCampaign.sortDirections' | cxTranslate
          }}</label>
          <div class="col-xl-2 col-form-label">
            <div class="form-check">
              <input class="form-check-input" type="radio" name="sortDirection" id="sortDirectionDesc" value="desc" ng-control="sortDirection"
                [(ngModel)]="sortDirection" (change)="onChangeSort()" />
                <label class="form-check-label" for="sortDirectionDesc">
                  {{ 'customManufacturerCampaign.sortDirection.desc' | cxTranslate }}
                </label>
              </div>
            </div>
            <div class="col-xl-2 col-form-label">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="sortDirection" id="sortDirectionAsc" value="asc" ng-control="sortDirection"
                  [(ngModel)]="sortDirection" (change)="onChangeSort()" />
                  <label class="form-check-label" for="sortDirectionAsc">
                    {{ 'customManufacturerCampaign.sortDirection.asc' | cxTranslate }}
                  </label>
                </div>
              </div>
              <div class="col-xl-2 col-form-label">
                <div class="form-check">
                  <input
                    type="checkbox"
                    id="showOldData"
                    class="form-control"
                    [(ngModel)]="showOldData"
                    name="showOldData"
                    [value]="showOldData"
                    (click) ="onShowOldData()"
                    />
                    <label for="showOldData" class="form-check-label">{{
                      'customManufacturerCampaign.search.showOldData' | cxTranslate
                    }}</label>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-3 col-sm-6"></div>
                <div class="col-md-3 col-sm-6"></div>
                <div class="col-md-3 col-sm-6"></div>
                <div class="col-md-3 col-sm-6">
                  <button class="btn btn-secondary btn-block mb-3" type="button" (click) ="downloadOverview()">
                    {{ 'customManufacturerCampaign.buttons.downloadCsv' | cxTranslate }}
                  </button>
                </div>
              </div>
            </div>
            @if (overview || errorOverview) {
              <!-- TABLE -->
              <table class="table manufacturer-campaign-table">
                <thead class="manufacturer-campaign-header">
                  <th scope="col">&nbsp;</th>
                  <th scope="col">&nbsp;</th>
                  <th scope="col">&nbsp;</th>
                  <th scope="col">&nbsp;</th>
                  <th scope="col">&nbsp;</th>
                  <th scope="col" colspan="2" class="validDateGroup">
                    {{ 'customManufacturerCampaign.validDate' | cxTranslate }}
                  </th>
                  <th scope="col" colspan="1" class="editableUntilGroup">
                    {{ 'customManufacturerCampaign.editableUntil' | cxTranslate }}
                  </th>
                </thead>
                <thead class="manufacturer-campaign-thead-mobile">
                  <th scope="col" class="manufacturer">
                    {{ 'customManufacturerCampaign.manufacturer' | cxTranslate }}
                  </th>
                  <th scope="col" class="campaign">
                    {{ 'customManufacturerCampaign.campaign' | cxTranslate }}
                  </th>
                  <th scope="col" class="productCode">
                    {{ 'customManufacturerCampaign.productCode' | cxTranslate }}
                  </th>
                  <th scope="col" class="productInfo">
                    {{ 'customManufacturerCampaign.productInfo' | cxTranslate }}
                  </th>
                  <th scope="col" class="value">
                    {{ 'customManufacturerCampaign.value' | cxTranslate }}
                  </th>
                  <th scope="col" class="validFrom">
                    {{ 'customManufacturerCampaign.validFrom' | cxTranslate }}
                  </th>
                  <th scope="col" class="validTo">
                    {{ 'customManufacturerCampaign.validTo' | cxTranslate }}
                  </th>
                  <th scope="col" class="validTo">
                    {{ 'customManufacturerCampaign.validTo' | cxTranslate }}
                  </th>
                </thead>
                <tbody>
                  @if (responses.length !== 0) {
                    @for (manufacturerCampaign of responses; track manufacturerCampaign; let isFirst = $first; let isOdd = $odd; let isLast = $last) {
                      @if (isFirst) {
                        <tr>
                          <td colspan="10" class="top-bottom-spacer"></td>
                        </tr>
                      }
                      @if (!isFirst) {
                        <tr>
                          <td colspan="10" class="divider"><hr/></td>
                        </tr>
                      }
                      <tr [class.active]="manufacturerCampaign.withNotifications"
            (click)="openDetails(
            manufacturerCampaign?.expired,
            manufacturerCampaign?.name,
            manufacturerCampaign?.id,
            manufacturerCampaign?.manufacturer,
            manufacturerCampaign?.productCode,
            manufacturerCampaign?.productName,
            manufacturerCampaign?.productEan,
            manufacturerCampaign?.supplierArticleNumber,
            manufacturerCampaign?.noSerialNumberCheck,
            manufacturerCampaign?.startedValidity,
            manufacturerCampaign?.tradeInProduct,
            manufacturerCampaign?.numberOfCombinations,
            manufacturerCampaign?.combiProducts,
            manufacturerCampaign?.combiValue1,
            manufacturerCampaign?.campaignCodeInput)"
                        >
                        <td class="manufacturer">
                          <div class="d-md-none manufacturer-campaign-label">
                            {{ 'customManufacturerCampaign.manufacturer' | cxTranslate }}
                          </div>
                          <div class="manufacturer-campaign-value">
                            {{ manufacturerCampaign?.manufacturer }}
                          </div>
                        </td>
                        <td class="campaign">
                          <div class="d-md-none manufacturer-campaign-label">
                            {{ 'customManufacturerCampaign.campaign' | cxTranslate }}
                          </div>
                          @if (manufacturerCampaign?.numberOfCombinations == 'ZERO') {
                            <div class="manufacturer-campaign-value">
                              {{ manufacturerCampaign?.id }} - {{ manufacturerCampaign?.name }}
                            </div>
                          } @else {
                            <div class="manufacturer-campaign-value">
                              {{ manufacturerCampaign?.id }} - {{ 'customManufacturerCampaign.combiCampaign' | cxTranslate }} - {{ manufacturerCampaign?.name }}
                            </div>
                          }
                        </td>
                        <td class="productCode">
                          <div class="d-md-none manufacturer-campaign-label">
                            {{ 'customManufacturerCampaign.productCode' | cxTranslate }}
                          </div>
                          <div class="manufacturer-campaign-value">
                            {{ manufacturerCampaign?.productCode }}
                          </div>
                        </td>
                        <td class="productName">
                          <div class="d-md-none manufacturer-campaign-label">
                            {{ 'customManufacturerCampaign.productInfo' | cxTranslate }}
                          </div>
                          <div class="manufacturer-campaign-value">
                            {{ manufacturerCampaign?.productName }}
                          </div>
                        </td>
                        <td class="value">
                          <div class="d-md-none manufacturer-campaign-label">
                            {{ 'customManufacturerCampaign.value' | cxTranslate }}
                          </div>
                          @if (manufacturerCampaign?.numberOfCombinations == 'ZERO') {
                            <div class="manufacturer-campaign-value">
                              {{ manufacturerCampaign?.formattedValue }}
                            </div>
                          }
                          @if (manufacturerCampaign?.numberOfCombinations == 'ONE' && manufacturerCampaign?.combiValue1) {
                            <div class="manufacturer-campaign-value combi-value">
                              {{ 'customManufacturerCampaign.combiValue1' | cxTranslate }} {{ manufacturerCampaign?.combiValue1 }}
                            </div>
                          }
                          @if (manufacturerCampaign?.numberOfCombinations == 'TWO') {
                            @if (manufacturerCampaign?.combiValue1) {
                              <div class="manufacturer-campaign-value combi-value">
                                {{ 'customManufacturerCampaign.combiValue1' | cxTranslate }} {{ manufacturerCampaign?.combiValue1 }}
                              </div>
                            }
                            <div class="combi-value-space">&nbsp;</div>
                            @if (manufacturerCampaign?.combiValue2) {
                              <div class="manufacturer-campaign-value combi-value">
                                {{ 'customManufacturerCampaign.combiValue2' | cxTranslate }} {{ manufacturerCampaign?.combiValue2 }}
                              </div>
                            }
                          }
                        </td>
                        <td class="date">
                          <div class="d-md-none manufacturer-campaign-label">
                            {{ 'customManufacturerCampaign.validFrom' | cxTranslate }}
                          </div>
                          <div class="manufacturer-campaign-value">
                            {{ manufacturerCampaign?.formattedValidFrom }}
                          </div>
                        </td>
                        <td class="date">
                          <div class="d-md-none manufacturer-campaign-label">
                            {{ 'customManufacturerCampaign.validTo' | cxTranslate }}
                          </div>
                          <div class="manufacturer-campaign-value">
                            {{ manufacturerCampaign?.formattedValidTo }}
                          </div>
                        </td>
                        <td class="date">
                          <div class="d-md-none manufacturer-campaign-label">
                            {{ 'customManufacturerCampaign.editableUntil' | cxTranslate }}
                          </div>
                          <div class="manufacturer-campaign-value">
                            {{ manufacturerCampaign?.formattedEditableUntil }}
                          </div>
                        </td>
                        <td class="value" >
                          <a
                            class="downloadCalendar"
                            title="{{'customManufacturerCampaign.buttons.downloadCalendar' | cxTranslate}}"
                            (click)="downloadCalendar($event, manufacturerCampaign.id)">
                            <cx-icon class="fas fa-calendar-days"></cx-icon>
                          </a>
                        </td>
                      </tr>
                      @if (isLast) {
                        <tr>
                          <td colspan="10" class="top-bottom-spacer"></td>
                        </tr>
                      }
                    }
                  } @else {
                    @if (responses.length === 0) {
                      <tr>
                        <td colspan="10">
                          {{ 'customManufacturerCampaign.emptyTable' | cxTranslate }}
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            } @else {
              <cx-spinner></cx-spinner>
            }
          }

